'use strict';

wbApp.controller('PaymentCtrl', ['$scope', '$translate', '$window', 'securitySvc', 'paymentsSvc', 'messageBoxSvc', 'terminalSvc', 'tenantSettingSvc',
    function ($scope, $translate, $window, securitySvc, paymentsSvc, messageBoxSvc, terminalSvc, tenantSettingSvc) {

        $scope.tabs = [
        {
            title: 'TXT_TITLE_PAYMENTS',
            template: 'payments/payment-tab.html'
        }];

        $scope.terminal = terminalSvc.getTerminalSetting();

        $scope.terminalChanged = function (terminal) {
            terminalSvc.setTerminalSetting(terminal);
        }

        $scope.tabs.activeTab = 0;

        $scope.model = paymentsSvc.initializePaymentEditModel();

        $scope.onClearBtnClick = function () {
            paymentsSvc.clearPaymentEditModel($scope.model);
        }

        $scope.onSaveBtnClick = function () {
            messageBoxSvc.showConfirmClientNotification({
                userSetting: ['confimNotificationCourseRegistrationPayment'],
                showSendSmsNotification: false,
                callback: function (notificationConfig) {
                    savePayment(notificationConfig.sendEmailNotification);
                }
            });
        }

        $scope.isPaymentValid = function () {
            if ($scope.terminal.isRequired && !$scope.terminal.terminalID) {
                return false;
            }

            return  paymentsSvc.isPaymentEditModelValid($scope.model);
        }

        function savePayment(sendNotification) {
            var model = $scope.model;

            paymentsSvc.savePaymentEditModel(model, sendNotification, success, error);

            function success(data) {
                if (model.paymentTypeID === 1 && securitySvc.isInRole('Payment.CashReceipt') && securitySvc.isInRole('Reports')) { // Cash
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_CONFIRM_PRINT',
                        message: 'TXT_CONFIRM_PRINT_CASH_RECEIPT_MESSAGE',
                        buttons: [{
                            text: 'TXT_BTN_NO',
                            callback: function () { finalizePayment(); }
                        }, {
                            text: 'TXT_BTN_PRINT',
                            callback: function () { finalizePayment(); onPrintReceipt(data.paymentID); }
                        }]
                    });
                } else if (model.paymentTypeID === 2 && securitySvc.isInRole('Payment.ConfirmationReport') && securitySvc.isInRole('Reports') &&
                    tenantSettingSvc.settings.autoPaymentConfirmationPrintForCardPayments) { // Card
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_TITLE_CONFIRM_PRINT',
                        message: 'TXT_CONFIRM_PRINT_PAYMENT_EVIDENCE_MESSAGE',
                        buttons: [{
                            text: 'TXT_BTN_NO',
                            callback: function () { finalizePayment(); }
                        }, {
                            text: 'TXT_BTN_PRINT',
                            callback: function () { finalizePayment(); onPrintPaymentEvidence(data.paymentID); }
                        }]
                    });
                } else {
                    finalizePayment();
                }
            }

            function error(data) {
                $scope.serverError = data;
            }
        }

        function onPrintReceipt(paymentID) {
            $window.open('/Admin/Report/CashReceipt?PaymentID=' + paymentID,
                '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
        }

        function onPrintPaymentEvidence(paymentID) {
            $window.open('/Admin/Report/PaymentConfirmation?PaymentID=' + paymentID,
                '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
        }

        $scope.onClearBtnClick();

        function finalizePayment() {
            $scope.onClearBtnClick();
            //notificationSvc.notifyInfo(
            //    $translate.instant('TXT_ALERT_TITLE_PAYMENT_SAVED'));
        }
}]);